export default __webpack_public_path__ + "static/media/img_3.5a7d93f4.png";